import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedVideocam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5 24C4.34688 24 3.78776 23.7674 3.32266 23.3023C2.85755 22.8372 2.625 22.2781 2.625 21.625V7.375C2.625 6.72187 2.85755 6.16276 3.32266 5.69766C3.78776 5.23255 4.34688 5 5 5H19.25C19.9031 5 20.4622 5.23255 20.9273 5.69766C21.3924 6.16276 21.625 6.72187 21.625 7.375V12.7187L26.375 7.96875V21.0312L21.625 16.2812V21.625C21.625 22.2781 21.3924 22.8372 20.9273 23.3023C20.4622 23.7674 19.9031 24 19.25 24H5Z",
		fill: "url(#paint0_linear_8512_20578)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_8512_20578",
		x1: 2.50003,
		y1: 24.25,
		x2: 26.5,
		y2: 4.75001,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedVideocam;
